import { render } from "./JournalView.vue?vue&type=template&id=1c4d5ffa&scoped=true"
import script from "./JournalView.vue?vue&type=script&lang=js"
export * from "./JournalView.vue?vue&type=script&lang=js"

import "./JournalView.vue?vue&type=style&index=0&id=1c4d5ffa&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4d5ffa"]])

export default __exports__